import { render, staticRenderFns } from "./SpaNav.vue?vue&type=template&id=314bb04a&scoped=true"
import script from "./SpaNav.vue?vue&type=script&lang=js"
export * from "./SpaNav.vue?vue&type=script&lang=js"
import style0 from "./SpaNav.vue?vue&type=style&index=0&id=314bb04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314bb04a",
  null
  
)

export default component.exports